import { doGet, doPost, doPut } from "../base";

const KARIE_USERS_URL = "/user_auth/karie_users";
const RESPONSES_URL = "/user_auth/questionnaires";

const SET_DAFAULTS = ({ limit, offset, sort }) => {
    let params = [];
    if (limit && limit !== null) {
        params.push("limit=" + limit);
    }
    if (offset && offset !== null) {
        params.push("offset=" + offset);
    }
    if (sort && sort !== null) {
        params.push("sort=" + sort);
    }

    return params;
}

export const fetchKarieUsers = async ({ patientId, limit, offset, sort, name }) => {

    var url = KARIE_USERS_URL;
    if (patientId) {
        url += "/" + patientId;
    }
    let params = SET_DAFAULTS({ limit, offset, sort });
    if (name && name !== null) {
        params.push("name=" + name);
    }
    for (let i = 0; i < params.length; i++) {
        url += i > 0 ? "&" + params[i] : "?" + params[i];
    }

    return await doGet(url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    });
};

export const fetchKarieUserInfo = async (patientId) => {

    var url = KARIE_USERS_URL;

    if (!patientId || patientId === null) {
        throw new Error("patientId cannot be null.");
    }

    url += "/" + patientId;

    return await doGet(url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    });
};

export const fetchKarieUserAdherece = async (patientId) => {

    var url = KARIE_USERS_URL;

    if (!patientId || patientId === null) {
        throw new Error("patientId cannot be null.");
    }
    url += "/" + patientId + "/adherence";

    return await doGet(url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    });
};

export const fetchKarieUserMedication = async (patientId) => {

    var url = KARIE_USERS_URL;

    if (!patientId || patientId === null) {
        throw new Error("patientId cannot be null.");
    }
    url += "/" + patientId + "/medication";

    return await doGet(url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    });
};

export const fetchKarieUserResponses = async (questionnaireId, patientId) => {

    var url = RESPONSES_URL;

    if (!patientId || patientId === null) {
        throw new Error("patientId cannot be null.");
    }
    if (!questionnaireId || questionnaireId === null) {
        throw new Error("questionnaireId cannot be null.");
    }
    url += "/" + questionnaireId + "/assign/responses/" + patientId;

    return await doGet(url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    });
};

export const unAssignDevice = async (patientId) => {
    let url = `${KARIE_USERS_URL}/${patientId}/unassign_device`;
    if (!patientId || patientId === null) {
        throw new Error("patientId cannot be null.");
    }
    return await doPost({}, url)
};

export const updatePatientInfo = async (reqBody, deviceId, patientId, pharmacyId) => {
    let url = `${KARIE_USERS_URL}/patient/update${deviceId? `?deviceId=${deviceId}`: ""}${patientId? "?patientId="+patientId:""}`;
    if (!(patientId || deviceId)) {
        throw new Error("Could not find neither patient nor device ")
    }
    if (!reqBody) {
        throw new Error("Request Body Can't be empty")
    }
    if (pharmacyId) {
        url += `&pharmacyId=${pharmacyId}`
    }

    return await doPut(reqBody, url)
}